import React from 'react';
import PropTypes from 'prop-types';
import { Card, Divider, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { Grid, Row, Col } from 'react-flexbox-grid';

const ReservationsConfigResto = ({ restaurant, onEditConfigResto, listAverageReservationTime, listPreviousCancellationTime }) => {
    return (
        <div>
            <Grid className="gridCont">
                <Row center="md">
                    <Col xs={12} sm={12} md={8}>
                        <Card
                        actions={[<Tooltip placement="top" title={"Editar perfíl"}><EditOutlined onClick={onEditConfigResto}/></Tooltip>]}>
                            <Row start="xs">
                                <Col xs={12}>
                                    { restaurant.totalCapacity !== undefined && <h3>Capacidad total: {restaurant.totalCapacity}</h3>}
                                </Col>
                            </Row>
                            <Row start="xs">
                                <Col xs={12}>
                                    { restaurant.reservationCapacity !== undefined && <h3>Capacidad para reservas: {restaurant.reservationCapacity}</h3>}
                                </Col>
                            </Row>
                            <Row start="xs">
                                <Col xs={12}>
                                    { restaurant.automaticReservations !== undefined && <h3>Aceptación de reservas: {restaurant.automaticReservations ? "Automatico" : "Manual"}</h3>}
                                </Col>
                            </Row>
                            <Divider></Divider>
                            <Row start="xs">
                                <Col xs={12}>
                                    { restaurant.minPlacesPerReservation !== undefined && <h3>Cantidad mínima de personas por reserva: {restaurant.minPlacesPerReservation}</h3>}
                                </Col>
                            </Row>
                            <Row start="xs">
                                <Col xs={12}>
                                    { restaurant.maxPlacesPerReservation !== undefined && <h3>Cantidad máxima de personas por reserva: {restaurant.maxPlacesPerReservation}</h3>}
                                </Col>
                            </Row>
                            <Divider></Divider>
                            <Row start="xs">
                                <Col xs={12}>
                                    { listAverageReservationTime && <h3>Promedio de permanencia por reserva: {listAverageReservationTime[restaurant.averageReservationTime]}</h3>}
                                </Col>
                            </Row>
                            <Divider></Divider>
                            <Row start="xs">
                                <Col xs={12}>
                                    { restaurant.minimumPreviousReservationHours !== undefined && <h3>Tiempo mínimo de anticipo de reserva (horas): {restaurant.minimumPreviousReservationHours}</h3>}
                                </Col>
                            </Row>
                            <Row start="xs">
                                <Col xs={12}>
                                    { restaurant.maximumPreviousReservationDays !== undefined && <h3>Días previos de reserva: {restaurant.maximumPreviousReservationDays}</h3>}
                                </Col>
                            </Row>
                            <Divider></Divider>
                            <Row start="xs">
                                <Col xs={12}>
                                    { listPreviousCancellationTime && <h3>Tiempo previo límite para cancelar una reserva: {listPreviousCancellationTime[restaurant.reservePreviousCancellationTime]}</h3>}
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Grid>
        </div>
    );
};

ReservationsConfigResto.propTypes = {
    onEditConfigResto: PropTypes.func,
};

export default ReservationsConfigResto;